// extracted by mini-css-extract-plugin
export default {"designerSection":"Designer_designerSection__trWGc","designerPic":"Designer_designerPic__z2ACX"};